import React from "react";
import { Alert } from "react-bootstrap";

export default function Alerts(props) {
  const hasAlerts = () => {
    return (props.alerts !== undefined && props.alerts.length > 0)
  }
  const hasBackendAlerts = () => {
    return (props.backendalerts !== undefined && props.backendalerts.length > 0)
  }
  return hasAlerts() || hasBackendAlerts() ? (
    <Alert variant="danger" {...props} alerts={undefined}>
      <ul>
        {hasAlerts() && props.alerts.map((message, index) => (
          <li key={`FE-${index}`}>{message}</li>
        ))}
        {hasBackendAlerts() && props.backendalerts.map((message, index) => (
          <li key={`BE-${index}`}>{message.errorMessage}</li>
        ))}
      </ul>
    </Alert>
  ) : null;
}